import { Button, Group } from '@mantine/core';
import { modals } from '@mantine/modals';
import { useState } from 'react';

import { useSetCustomsControl } from '@hooks/declaration';

interface DeclarationCustomsControlProps {
  declarationId: string;
}
export const DeclarationCustomsControl: React.FC<DeclarationCustomsControlProps> = ({ declarationId }) => {
  const setCustomsControlMutation = useSetCustomsControl();
  const [isLoading, setIsLoading] = useState(false);

  const onConfirm = async () => {
    setIsLoading(true);
    await setCustomsControlMutation.mutateAsync({ id: declarationId });
    setIsLoading(false);
    modals.closeAll();
  };

  return (
    <>
      <div>Are you sure you want to move this declaration in control?</div>
      <Group>
        <Button onClick={modals.closeAll} variant="outline">
          Cancel
        </Button>
        <Button onClick={onConfirm} loading={isLoading}>
          Confirm
        </Button>
      </Group>
    </>
  );
};
